import React from 'react'
import PropType from 'prop-types'

import ThemeProvider from '@cred/react-theme/ThemeProvider'

import { getMetaQuery } from 'utils/data'

import CopyOnly from './copy-only'
import Interactive from './interactive'
import withFontTheme from '../hocs/with-font-theme/withFontTheme'
import RichCtaFeaturedLenderBanner from './featured-lender-banner'

const CopyOnlyWithFontTheme = withFontTheme(CopyOnly)

const RichCta = ({
  url,
  formUrl,
  variation,
  theme,
  utms,
  title,
  body,
  ctaText,
  form,
  nmls = false,
  metaParams,
  verticals,
  type,
}) => {
  const queryString = Object.keys(utms)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(utms[k])}`)
    .join('&')
  const metaQuery = getMetaQuery({ ...metaParams, marketplace: verticals, type }, theme)
  const href = `${url}?${queryString}${metaQuery}`
  const formHref = `${formUrl}?${queryString}${metaQuery}`

  switch (variation) {
    case 'copy-only':
      return (
        <CopyOnlyWithFontTheme
          href={href}
          theme={theme}
          title={title}
          body={body}
          ctaText={ctaText}
          nmls={nmls}
        />
      )
    case 'interactive':
      return (
        <Interactive
          href={formHref}
          theme={theme}
          title={title}
          body={body}
          ctaText={ctaText}
          Form={form}
          queryString={queryString}
          metaQuery={metaQuery}
          verticals={verticals}
        />
      )
    case 'nerdwallet-banner':
      return (
        // the color theme for the nerdwallet-banner variaition is always nerdwallet regardless of the theme prop
        <ThemeProvider themeName="nerdwallet">
          <RichCtaFeaturedLenderBanner theme="nerdwallet" />
        </ThemeProvider>
      )

    case 'featured-lender-banner':
      return <RichCtaFeaturedLenderBanner theme={theme} />
    default:
      return null
  }
}

RichCta.propTypes = {
  url: PropType.string.isRequired,
  formUrl: PropType.string,
  variation: PropType.string.isRequired,
  form: PropType.func,
  utms: PropType.object.isRequired,
  title: PropType.string.isRequired,
  theme: PropType.string.isRequired,
  body: PropType.string.isRequired,
  ctaText: PropType.string.isRequired,
  nmls: PropType.bool,
  metaParams: PropType.object,
  verticals: PropType.oneOfType([PropType.string, PropType.array]),
  type: PropType.string,
}

export default RichCta
